import { LabNotebook, LabNotebookFilters } from "../../types/LabNotebook";
import { DefinedPropertyObject, IEntityMinimalModel } from "../../../api/GenericTypes";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { ProjectsVirtualizedSelectForm } from "../../../common/forms/EntityForms/formsVirtualized/ProjectsVirtualizedSelectForm";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import {
  ILockableEntityForm,
  LockableEntityDefaultFilterFormValues,
  lockableEntityFiltersToForm,
  lockableEntityFormToFilters,
} from "../../../common/sidebar/filtersidebar/GenericFilters/LockableEntityFilterFormModels";
import {
  ISignableEntityForm,
  SignableEntityDefaultFilterFormValues,
  signableEntityFiltersToForm,
  signableEntityFormToFilters,
} from "../../../common/sidebar/filtersidebar/GenericFilters/SignableEntityFilterFormModels";
import {
  ISoftDeletableEntityForm,
  SoftDeletableEntityDefaultFilterFormValues,
  softDeletableEntityFiltersToForm,
  softDeletableEntityFormToFilters,
} from "../../../common/sidebar/filtersidebar/GenericFilters/SoftDeletableEntityFilterFormModels";
import { CombinedModificationRecordEntityFilterForm } from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
import { SignableEntityFilterForm } from "../../../common/sidebar/filtersidebar/GenericFilters/SignableEntityFilterForm";
import { defaultLabNotebooksFilters } from "./LabNotebooksTable";

export interface LabNotebookFilterForm
  extends ICombinedModificationRecordEntityForm,
    ILockableEntityForm,
    ISignableEntityForm,
    ISoftDeletableEntityForm {
  projectIds?: IEntityMinimalModel[] | undefined | null;
}
const defaultValues: DefinedPropertyObject<LabNotebookFilterForm> = {
  projectIds: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
  ...LockableEntityDefaultFilterFormValues,
  ...SignableEntityDefaultFilterFormValues,
  ...SoftDeletableEntityDefaultFilterFormValues,
};
export const labNotebooksFormToFilters = (form: LabNotebookFilterForm): LabNotebookFilters => {
  let filters: LabNotebookFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
    ...lockableEntityFormToFilters(form),
    ...signableEntityFormToFilters(form),
    ...softDeletableEntityFormToFilters(form),
  };
  filters.projectIds =
    Array.isArray(form.projectIds) && form.projectIds.length > 0 ? form.projectIds?.map((d) => d.id) : null;
  return filters;
};

/**
 * Converts LabNotebookFilters to LabNotebookFilterForm
 * @param filters LabNotebookFilters
 * @returns LabNotebookFilterForm
 * @author @CorradoSurmanowicz
 */
export const labNotebooksFiltersToForm = (filters: LabNotebookFilters): LabNotebookFilterForm => {
  return {
    projectIds: filters.projectIds ? filters.projectIds.map((id) => ({ id, name: "" })) : null,
    ...combinedModificationRecordEntityFiltersToForm(filters),
    ...lockableEntityFiltersToForm(filters),
    ...signableEntityFiltersToForm(filters),
    ...softDeletableEntityFiltersToForm(filters),
  };
};

export const LabNotebookFilterBar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<LabNotebook, LabNotebookFilterForm, LabNotebookFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultLabNotebooksFilters}
      formToFilters={labNotebooksFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <ProjectsVirtualizedSelectForm id="projectIds" control={control} isMulti={true} />

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />

          <SignableEntityFilterForm control={control} initialValues={initialValues} />

          {/* <SoftDeletableEntityFilterForm control={control} currentTab={currentTab} initialValues={initialValues} /> */}
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
